// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `



 .featuredWholeCover{
    margin-bottom: 30px;
 }

.solidLine::before,
.solidLine::after {
    display: inline-block;
    content: "";
    border-top: .2rem solid gold;
    width: 2rem;
    margin: 0 1rem;
    /* transform: translateY(-1rem); */
    transform: translateY(-150%);
}


.CMSCover{
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 20px;
  cursor: pointer;
  /* margin-left: 30px;
  padding-right: 30px; */
}

.viewCourse{
  background-color: gold;
  margin-top: 3px;
  border: none;
  padding: 10px 20px;
  border-radius: 3px;
  font-weight: 600;
  cursor: pointer;
}

.CMSWording{
  width: 100%;
    text-align: center;
    display: flex;
    justify-content: space-around;

  }

.CourseCardsGrid{
    display: grid;
    grid-template-columns: repeat(auto-fit,minmax(500px,1fr)) ;
}
  
.courseWholeCover{
  display: flex;
  justify-content: space-around;
  width: 100%;
  max-height: 500px;
  /* background-color: aqua; */
  /* background-color: red; */
  /* border: 3px solid white; */
  
  padding: 30px;
}

.FeaturedWholeNewCard{
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: 450px;
    cursor: pointer;
    /* background-color: blueviolet; */
    /* height: 300px; */
    border: 2px solid gray;
    border-radius: 5px;
    transition: border .1s ease-in-out;

}
.FeaturedWholeNewCard:hover{

  
    border: 2px solid rgb(46, 45, 45);
   

}

.courseImg{
 flex: 1 1;
 overflow: hidden;
}
.courseImg img{
  width: 100%;
  height: 100%;
  overflow: hidden;
  object-fit: cover;
}

.workingWholeCover{
  flex: 1.3 1;
  padding: 20px;
  overflow: hidden;
}

.courseMetrics {
  
    overflow: hidden;
}
.courseMetrics p{
  padding: 0;
  margin: 0;
  font-size :15px;
  /* background-color: red; */
  color: black;
}

.exploreCourses{
    display: flex;
    justify-content: space-evenly;
}

.exploreCover{
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #003300;
    padding: 10px;
    border-radius: 3px;
    margin: 0;
    cursor: pointer;
    color: #003300;
    font-weight: 700;
}
.exploreCover p{
    margin: 0 10px;
    padding: 0;
}
.exploreCover .fontawesomIconhere{
    margin: 0;
    padding: 0;
}


@media screen and (max-width: 730px){     

  .courseWholeCover{
    display: flex;
    justify-content: space-around;
    width: 100%;
    max-height: 500px;
    /* background-color: aqua; */
    
    padding: 5px;
  }

  .CourseCardsGrid{
    display: grid;
    grid-template-columns: repeat(auto-fit,minmax(300px,1fr)) ;
  }

  .courseImg{
    flex: .8 1;
    overflow: hidden;
   }


 }

`, "",{"version":3,"sources":["webpack://./src/Components/FeaturedCourses/FeaturedCourses.css"],"names":[],"mappings":";;;;CAIC;IACG,mBAAmB;CACtB;;AAED;;IAEI,qBAAqB;IACrB,WAAW;IACX,4BAA4B;IAC5B,WAAW;IACX,cAAc;IACd,kCAAkC;IAClC,4BAA4B;AAChC;;;AAGA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf;wBACsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;IACT,kBAAkB;IAClB,aAAa;IACb,6BAA6B;;EAE/B;;AAEF;IACI,aAAa;IACb,0DAA0D;AAC9D;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,WAAW;EACX,iBAAiB;EACjB,4BAA4B;EAC5B,2BAA2B;EAC3B,6BAA6B;;EAE7B,aAAa;AACf;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,kCAAkC;IAClC,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;IAClB,kCAAkC;;AAEtC;AACA;;;IAGI,iCAAiC;;;AAGrC;;AAEA;CACC,SAAO;CACP,gBAAgB;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAS;EACT,aAAa;EACb,gBAAgB;AAClB;;AAEA;;IAEI,gBAAgB;AACpB;AACA;EACE,UAAU;EACV,SAAS;EACT,eAAe;EACf,2BAA2B;EAC3B,YAAY;AACd;;AAEA;IACI,aAAa;IACb,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;IACzB,aAAa;IACb,kBAAkB;IAClB,SAAS;IACT,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;AACA;IACI,cAAc;IACd,UAAU;AACd;AACA;IACI,SAAS;IACT,UAAU;AACd;;;AAGA;;EAEE;IACE,aAAa;IACb,6BAA6B;IAC7B,WAAW;IACX,iBAAiB;IACjB,4BAA4B;;IAE5B,YAAY;EACd;;EAEA;IACE,aAAa;IACb,0DAA0D;EAC5D;;EAEA;IACE,UAAQ;IACR,gBAAgB;GACjB;;;CAGF","sourcesContent":["\n\n\n\n .featuredWholeCover{\n    margin-bottom: 30px;\n }\n\n.solidLine::before,\n.solidLine::after {\n    display: inline-block;\n    content: \"\";\n    border-top: .2rem solid gold;\n    width: 2rem;\n    margin: 0 1rem;\n    /* transform: translateY(-1rem); */\n    transform: translateY(-150%);\n}\n\n\n.CMSCover{\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin-bottom: 20px;\n  cursor: pointer;\n  /* margin-left: 30px;\n  padding-right: 30px; */\n}\n\n.viewCourse{\n  background-color: gold;\n  margin-top: 3px;\n  border: none;\n  padding: 10px 20px;\n  border-radius: 3px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.CMSWording{\n  width: 100%;\n    text-align: center;\n    display: flex;\n    justify-content: space-around;\n\n  }\n\n.CourseCardsGrid{\n    display: grid;\n    grid-template-columns: repeat(auto-fit,minmax(500px,1fr)) ;\n}\n  \n.courseWholeCover{\n  display: flex;\n  justify-content: space-around;\n  width: 100%;\n  max-height: 500px;\n  /* background-color: aqua; */\n  /* background-color: red; */\n  /* border: 3px solid white; */\n  \n  padding: 30px;\n}\n\n.FeaturedWholeNewCard{\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    max-width: 450px;\n    cursor: pointer;\n    /* background-color: blueviolet; */\n    /* height: 300px; */\n    border: 2px solid gray;\n    border-radius: 5px;\n    transition: border .1s ease-in-out;\n\n}\n.FeaturedWholeNewCard:hover{\n\n  \n    border: 2px solid rgb(46, 45, 45);\n   \n\n}\n\n.courseImg{\n flex: 1;\n overflow: hidden;\n}\n.courseImg img{\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n  object-fit: cover;\n}\n\n.workingWholeCover{\n  flex: 1.3;\n  padding: 20px;\n  overflow: hidden;\n}\n\n.courseMetrics {\n  \n    overflow: hidden;\n}\n.courseMetrics p{\n  padding: 0;\n  margin: 0;\n  font-size :15px;\n  /* background-color: red; */\n  color: black;\n}\n\n.exploreCourses{\n    display: flex;\n    justify-content: space-evenly;\n}\n\n.exploreCover{\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border: 1px solid #003300;\n    padding: 10px;\n    border-radius: 3px;\n    margin: 0;\n    cursor: pointer;\n    color: #003300;\n    font-weight: 700;\n}\n.exploreCover p{\n    margin: 0 10px;\n    padding: 0;\n}\n.exploreCover .fontawesomIconhere{\n    margin: 0;\n    padding: 0;\n}\n\n\n@media screen and (max-width: 730px){     \n\n  .courseWholeCover{\n    display: flex;\n    justify-content: space-around;\n    width: 100%;\n    max-height: 500px;\n    /* background-color: aqua; */\n    \n    padding: 5px;\n  }\n\n  .CourseCardsGrid{\n    display: grid;\n    grid-template-columns: repeat(auto-fit,minmax(300px,1fr)) ;\n  }\n\n  .courseImg{\n    flex: .8;\n    overflow: hidden;\n   }\n\n\n }\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
